// System
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/app/store';
import { Button, Typography } from '@mui/material';

// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';

// Types
import { useUpdateProviderConfig } from '@Modal/hooks/providers/useUpdateProviderConfig';

export const DeleteProviderConfigModalDialog = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    showDeleteProviderConfigForm,
    setShowDeleteProviderConfigForm,
    handleDeleteProviderConfig,
    selectedProviderConfig,
  } = useUpdateProviderConfig();

  return (
    <ClosableModal
      name="SetupAviatorRoleDeleteModalDialog"
      title={`Delete ${selectedProviderConfig?.currency} config`}
      open={showDeleteProviderConfigForm}
      onClose={() => dispatch(setShowDeleteProviderConfigForm(false))}
      sx={{ width: '592px' }}
    >
      <CreateDialogLayout>
        <Typography variant="body1"> Are you sure you want to delete this config?</Typography>
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => dispatch(setShowDeleteProviderConfigForm(false))}
            >
              Cancel
            </Button>
          </AtLocator>
          <Button variant="contained" color="error" onClick={handleDeleteProviderConfig}>
            Delete
          </Button>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </ClosableModal>
  );
};
